import { FaWind } from "react-icons/fa6";
import CardLayout from "../common/CardLayout";
import TitleCard from "../common/TitleCard";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Table from "../common/table";
import { useEffect, useState } from "react";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import { format } from "date-fns";
import { orderBy } from "../../funcs";
import StatusOnOff from "../common/StatusOnOff";
import apiArComprimido from "../../services/apis/apiArComprimido";

export default function ArComprimido() {

    const unidadeId = getCurrentUnidadeId();
    const [leituras, setLeituras] = useState([]);

    useEffect(() => {
        (async () => {
            const res = await apiArComprimido.getByUnidadeId(unidadeId);
            const arComprimido = res.data;
            const leiturasArComprimido = arComprimido.map((arComprimido) => ({...arComprimido.leiturasArComprimido[0], nome: arComprimido.nome, arComprimidoId: arComprimido.id}));
                        
            orderBy(leiturasArComprimido, "arComprimidoId");
            setLeituras(leiturasArComprimido);
        })();
    },[unidadeId]);


    return <CardLayout>
    <Accordion
        type="single"
        defaultValue="item-1"
        collapsible="true"
    >
        <AccordionItem value="item-1">
            <div className="font-semibold">
                <AccordionTrigger>
                    <TitleCard>
                        Ar Comprimido
                        <p className="text-lg lg:text-4xl px-2">
                            <FaWind />
                        </p>
                    </TitleCard>
                </AccordionTrigger>
            </div>
            <AccordionContent>
                <div className="w-full">
                        <Table.Root>
                            <Table.Head>
                                {/* <Table.Header>
                                    <p className="font-bold">
                                        . . .
                                    </p>
                                </Table.Header> */}
                                <Table.Header>
                                    Ar Comprimido Id
                                </Table.Header>
                                <Table.Header>
                                    Nome
                                </Table.Header>
                                <Table.Header>
                                    Data Hora
                                </Table.Header>
                                <Table.Header>
                                    Pressão
                                </Table.Header>
                            </Table.Head>
                            <Table.Body>
                                {leituras?.map(
                                    (
                                        leitura
                                    ) => (
                                        <Table.Row
                                            key={
                                                leitura.id
                                            }
                                        >
                                            <Table.Data>
                                                {
                                                    leitura.arComprimidoId
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura.nome
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura?.dataHora ? format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss") === "01/01/0001 00:00:00" ? "Sem leitura" : format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss") : "Sem leitura"
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura?.pressao ? leitura.pressao : "Sem leitura"
                                                }
                                            </Table.Data>
                                        </Table.Row>
                                    )
                                )}
                            </Table.Body>
                        </Table.Root>
                </div>
            </AccordionContent>
        </AccordionItem>
    </Accordion>
</CardLayout>
}